import React from "react";
import LayoutMain from "../../components/Layout/Main/Main";
import ShoppingToolCollection from "../../Partials/ShopingTool/Collection";
import { Link } from "react-router-dom";


import DataShop from "../../Data/Shop";


const Shop = () => {
  return (
    <LayoutMain>
      <section className="bg-oliva pt-70 pb-70 pt-sm-25 pb-sm-40 position-relative">
        <div className="bg-dark-oliva our-products-half-bg-bottom"></div>
        <div className="container-3">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <h1 className="text-center shop-title">Shop</h1>
            </div>
          </div>
          <div className="row product-list">
            <ShoppingToolCollection data={DataShop} />
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="text-center mt-85 mt-sm-45">
                <Link
                  to="/"
                  className="btn btn-white-border btn-block center-block btn-all-product text-uppercase"
                >
                  Load More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </LayoutMain>
  );
};

export default Shop;
